import { Box } from '@mui/material';
import { axisClasses, BarChart } from '@mui/x-charts';
import { valueFormatter } from 'pages/DashboardPageClient/datasDash';
import { ChartPoint } from 'services/Dashboard/types';

interface BarChartYearProps {
  data?: ChartPoint[];
}

const BarChartYear = ({ data = [] }: BarChartYearProps) => {

  const chartSetting = {
    width: 1000,
    height: 400,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: 'translate(-20px, 0)',
      },
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#202940',
        width: '100%',
        height: '100%',
        borderRadius: 3,
        boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
        padding: 3,
      }}
    >
      <BarChart
        dataset={data}
        xAxis={[{ scaleType: 'band', dataKey: 'label' }]} // Label vindo do backend (Jan, Fev...)
        series={[
          {
            dataKey: 'value',
            label: 'Eventos por Ano',
            valueFormatter: (value) => valueFormatter ? valueFormatter({ value: value ?? 0 }) : `${value}`,
          },
        ]}
        {...chartSetting}
      />
    </Box>
  );
};

export default BarChartYear;
